import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import newsService from "../../services/news/newsService";
import sweetAlert from "../../utils/sweetAlert";
import { toast } from "react-toastify";

import "./News.css";

export default function NewsList() {

    const [news, setNews] = useState([]);

    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(1);

    const [pageSize] = useState(10);

    const [search, setSearch] = useState("");

    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        loadNews();
    }, [page, search]);

    const loadNews = async () => {

        try {

            setLoading(true);

            const response = await newsService.getList(
                page,
                pageSize,
                search
            );

            if (response.success) {

                setNews(response.data.items);

                setTotalPages(response.data.totalPages);

            }

        }
        catch (error) {

            console.log(error);

        }
        finally {

            setLoading(false);

        }

    };
    const handleDelete = async (id) => {

        const confirmed = await sweetAlert.confirmDelete();

        if (!confirmed) {

            return;

        }

        try {

            const response = await newsService.delete(id);

            if (response.success) {

                toast.success(response.message);

                loadNews();

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }

    };
    return (

        <AdminLayout>

            <div className="page-header">

                <h2>News</h2>

                <Link
                    to="/news/add"
                    className="btn btn-primary"
                >
                    Add News
                </Link>

            </div>
            <div className="d-flex mb-3 gap-2">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search news..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />

                <button
                    className="btn btn-primary"
                    disabled={loading}
                    onClick={() => setPage(1)}
                >
                    Search
                </button>
            </div>
            <div className="card">

                <div className="card-body">

                    <table className="table table-bordered">

                        <thead>

                            <tr>

                                <th>Title</th>

                                <th>Date</th>

                                <th>Status</th>

                                <th>Action</th>

                            </tr>

                        </thead>

                        <tbody>

                            {
                                loading ?

                                    <tr>
                                        <td colSpan="4" className="text-center">
                                            Loading...
                                        </td>
                                    </tr>

                                    :

                                    news.length === 0 ?

                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                No News Found
                                            </td>
                                        </tr>

                                        :

                                        news.map(item => (

                                            <tr key={item.newsId}>

                                                <td>
                                                    {item.newsTitle}
                                                </td>

                                                <td>
                                                    {item.newsDate
                                                        ? new Date(item.newsDate).toLocaleDateString("en-IN")
                                                        : "-"}
                                                </td>

                                                <td>
                                                    {
                                                        item.isActive
                                                            ? <span className="badge bg-success">Active</span>
                                                            : <span className="badge bg-danger">Inactive</span>
                                                    }
                                                </td>

                                                <td>

                                                    <Link
                                                        to={`/news/edit/${item.newsId}`}
                                                        className="btn btn-warning btn-sm me-2"
                                                    >
                                                        Edit
                                                    </Link>

                                                    <button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleDelete(item.newsId)}
                                                    >
                                                        Delete
                                                    </button>

                                                </td>

                                            </tr>

                                        ))
                            }

                        </tbody>

                    </table>

                </div>

            </div>

        </AdminLayout>

    );

}